import posthog, { PostHog } from 'posthog-js';
import { getConf } from '~/_v3/common/utils/auth.utils';

// const directPostHogApiHost = 'https://eu.posthog.com';
const reversedProxyApiHost = 'https://sniffy.my.silae.fr';

let postHogInstance: PostHog | null = null;
let initializationPromise: Promise<PostHog | null> | null = null;

export async function getPostHogInstance(): Promise<PostHog | null> {
	// Return existing instance if already initialized
	if (postHogInstance) {
		return postHogInstance;
	}

	// Return existing promise if initialization is in progress
	if (initializationPromise) {
		return initializationPromise;
	}

	// Start initialization
	initializationPromise = initializePostHog();
	return initializationPromise;
}

async function initializePostHog(): Promise<PostHog | null> {
	try {
		const config = await getConf();
		
		if (!config?.CONF?.SILAE_POST_HOG_ENABLED) {
			console.log('PostHog is disabled in configuration');
			return null;
		}

		const token = config.CONF.SILAE_POST_HOG_TOKEN;
		if (!token) {
			console.warn('PostHog token not found in configuration');
			return null;
		}

		const api_host = reversedProxyApiHost;
		posthog.init(token, {
			api_host,
			// because we are an SPA, we manually handle $pageView tracking
			// we don't care about pageleave for now
			// disable auto tracking by posthog (all the more as it leaks some JWT when logging via URL)
			debug: true,
			capture_pageview: false,
			capture_pageleave: false
			
		});

		postHogInstance = posthog;
		console.log('PostHog initialized successfully');
		return posthog;
	} catch (error) {
		console.error('Failed to initialize PostHog:', error);
		return null;
	}
}
